/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */


import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminSubjectClassifierService {

  constructor(private http: HttpClient) { }

  getSubjectTraining(type:string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/subjectclassifier/training/${type}`
      );
  }

  newSubjectTraining(model: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/subjectclassifier/training`,
        JSON.stringify(model)
      );
  }

  deleteSubjectTraining(id: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/subjectclassifier/training/${id}`
      );
  }

  classifySubject(content: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/subjectclassifier/classify`,
        { content: content }
      );
  }
}


// WEBPACK FOOTER //
// ./client/app/services/admin/admin-subjectclassifier.service.ts